import React from 'react'

import HeaderNavigationItem from '../HeaderNavigationItem'

import { Container, NavitemsList } from './styles'

interface IHeaderNavigationProps {
    navigationItems: {
        label: string;
        to: string;
    }[]
    className?: string;
    deleteNav?: boolean;
}

const HeaderNavigation: React.FC<IHeaderNavigationProps> = ({ navigationItems, className, deleteNav }) => {

    if (deleteNav) return <></>

    return (
        <Container className={className}>
            <NavitemsList>
                {
                    navigationItems.map((navigationItem) => (
                        <HeaderNavigationItem key={navigationItem.label} {...navigationItem} />
                    ))
                }
            </NavitemsList>
        </Container>
    )
}

export default HeaderNavigation